// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const ingotStack = defineModel({
  id: "ingot-stack",
  batchId: "future",
  name: "Ingot stack",
  tags: ["scenery","ingot","stack","low-poly","age-of-mcp","future"],
  summary: "Stacked metal ingots — the smith's and foundry's raw bar stock.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.38,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.06, 0.075, 0.5, 4), color: "#878d93", position: [-0.16, 0.075, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.075, 0.5, 4), color: "#9aa0a6", position: [0, 0.075, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.075, 0.5, 4), color: "#878d93", position: [0.16, 0.075, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.075, 0.5, 4), color: "#b3b8bd", position: [-0.08, 0.16, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.075, 0.5, 4), color: "#9aa0a6", position: [0.08, 0.16, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.075, 0.5, 4), color: "#b3b8bd", position: [0, 0.245, 0], rotation: [1.570796, 0, 0], scale: [1, 1, 0.55] },
    ],
  animations: [],
});
